// @flow

import * as React from "react";

type PropsType = {
    status?: "success" | "error" | "pending",
    heading?: string,
    content?: string,
};

const StatusBlock = (props: PropsType): React.Node => {
    const cssBaseClass = "status-block";
    const classList = [cssBaseClass];

    if (props.status) {
        classList.push(`${cssBaseClass}--${props.status}`);
    }

    return (
        <div className={classList.join(" ")}>
            <div className="status-block__heading">{props.heading}</div>

            {props.content}
        </div>
    );
};

export default StatusBlock;
